// extracted by mini-css-extract-plugin
export default {"nav":"nav___c6ce7bf26c2a453d","nextButton":"nextButton___d58d197913ab834b","action":"action___bcf5cca5bac8be30","backButtonWrap":"backButtonWrap___aeab3ddf49f74f6e"};